module.exports = __webpack_public_path__ + "static/media/logo-hor.d1892311.png";